<template>
  <div id="wrapper">
    <Header />
    <ProgressHUD
        ref="progress"
        :display="true"
    />

    <!-- Page Content -->
    <div v-if="userData" id="page-content-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="page-header">Checkout</h4>
                </div>
            </div>

            <div class="line checkout-box">
                <div class="cho-line line">
                    <h3>Order Summary</h3>
                    <input type="text">
                    <input type="text">
                    <h3 class="ta-right">Total: 000<i>G</i></h3>
                </div>
                <div class="cho-line line">
                    <h3>Billing Address</h3>
                    <label class="checkcontainer">User profile address
                      <input type="radio" name="radio" checked="checked">
                      <span class="checkmark"></span>
                    </label>
                    <label class="checkcontainer">Add new
                      <input type="radio" name="radio">
                      <span class="checkmark"></span>
                    </label>
                </div>
                <div class="line">
                    <div class="cho-line col-xs-12 col-sm-5 col-md-5 col-lg-5">
                        <h3>Payment Method</h3>
                        <select name="method" class="payment-method">
                            <option
                              value=""
                              disabled
                              selected
                            >Select from saved methods</option>
                            <option
                              v-for="(payment, key) in userData.paymentMethods"
                              :value="key"
                              v-bind:key="'paymentMethods' + key"
                            >{{ payment.name +' / '+ ((typeof(payment.value)=='object') ? (payment.value.number==undefined) ? payment.value.iban : payment.value.number : payment.value) }}</option>
                        </select>
                    </div>
                    <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                        <div class="line btn-box">
                            <a class="create-btn">Complete Checkout</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- /#page-wrapper -->
  </div>
</template>

<script>
import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import { Api, Toast } from './../../../services'

export default {
  name: 'Checkout',
  components: {
    Header,
    ProgressHUD,
  },
  data() {
    return {
      userData: null,
    }
  },
  async created() {
    try {
      var response = await Api.myProfile()
      this.userData = response.data.results.user

      await new Promise(resolve => this.$nextTick(resolve))
    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Marketplace/CheckoutNew/index.vue